import { render, staticRenderFns } from "./8c_doc.vue?vue&type=template&id=6d96189e"
import script from "./8c_doc.vue?vue&type=script&lang=js"
export * from "./8c_doc.vue?vue&type=script&lang=js"
import style0 from "./8c_doc.vue?vue&type=style&index=0&id=6d96189e&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports